export enum CommonStatus {
  ACTIVE = 1,
  INACTIVE= -1
}
